import React, { useId } from "react";
import PropTypes from "prop-types";

const WALLET_PATH =
  "M14.0889 2.2498C14.8661 2.24938 15.4434 2.24901 15.9434 2.38261C17.2924 2.74323 18.3465 3.79458 18.708 5.14043C18.7934 5.45824 18.8239 5.8075 18.835 6.21953C18.9808 6.2324 19.1211 6.24736 19.2559 6.26543C20.1626 6.38705 20.9643 6.65209 21.6055 7.29179C22.2466 7.93149 22.5119 8.73093 22.6338 9.63554C22.7499 10.4972 22.75 11.5858 22.75 12.9061V14.9939C22.75 16.3141 22.7499 17.4029 22.6338 18.2645C22.5119 19.1688 22.2464 19.9676 21.6055 20.6072C20.9643 21.2469 20.1626 21.512 19.2559 21.6336C18.3924 21.7494 17.3014 21.7498 15.9785 21.7498H9.97363C8.19182 21.7498 6.75558 21.7499 5.62598 21.5984C4.45325 21.4411 3.46591 21.1044 2.68164 20.3221C1.89742 19.5397 1.55908 18.5545 1.40137 17.3846C1.24949 16.2575 1.24997 14.8235 1.25 13.0457V5.17461C1.25015 3.55937 2.56262 2.2499 4.18164 2.2498H14.0889ZM17.5 11.9998C16.3954 11.9998 15.5 12.8952 15.5 13.9998C15.5 15.1044 16.3954 15.9998 17.5 15.9998C18.6046 15.9998 19.5 15.1044 19.5 13.9998C19.5 12.8952 18.6046 11.9998 17.5 11.9998ZM4.18164 4.2C3.642 4.2 3.20425 4.63625 3.2041 5.17461C3.2041 5.71308 3.64191 6.15019 4.18164 6.15019H15.9775C16.2899 6.15018 16.5894 6.14965 16.876 6.15117C16.867 5.89931 16.8505 5.7613 16.8193 5.64531C16.6386 4.97247 16.1119 4.44678 15.4375 4.2664C15.2203 4.20833 14.9259 4.2 13.9541 4.2H4.18164Z";

const FinanceIcon = ({ selected, width, height, className, ...props }) => {
  const id = useId().replace(/:/g, "");
  const gradientId = `finance-wallet-gradient-${id}`;

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        opacity={selected ? undefined : "0.5"}
        fillRule="evenodd"
        clipRule="evenodd"
        d={WALLET_PATH}
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="21.2615"
          y1="6.25421"
          x2="6.37225"
          y2="23.1651"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D946EF" />
          <stop offset="1" stopColor="#67E8F9" />
        </linearGradient>
      </defs>
    </svg>
  );
};

FinanceIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

FinanceIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default FinanceIcon;
